import React from 'react';

import { useReturns } from '../../../hooks/useReturns';
import {
  AccountTotalEntriesDescription,
  AccountTotalEntriesLabel
} from '../../AccountTotalEntriesDescription';

export const AccountReturnsDescription = () => {
  const { pagination } = useReturns();

  if (!pagination) return null;

  return (
    <AccountTotalEntriesDescription
      label={AccountTotalEntriesLabel.Return}
      totalEntries={pagination.totalEntries}
    />
  );
};
